export default "__VITE_ASSET__DdSA7lrA__"